import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

type Props = {
	label: string;
	qaSelectorLabel: string;
};

export function Label({ qaSelectorLabel, label }: Props): JSX.Element {
	return (
		<Box>
			<Heading size="h5" sx={{ fontWeight: 'bold', lineHeight: 1.2 }} data-qa={qaSelectorLabel}>
				{label}
			</Heading>
		</Box>
	);
}
